import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { useState } from "react";

const AccordionItem1 = ({
  header,
  content,
  index,
  expandedIndex,
  setExpandedIndex,
  ...rest
}) => {
  const isExpanded = index === expandedIndex;

  const handleToggle = () => {
    setExpandedIndex(isExpanded ? null : index);
  };

  return (
    <Item
      {...rest}
      header={
        <div
          className="flex justify-between items-center px-4 py-4 w-full text-start"
          onClick={handleToggle}
        >
          {header}
          <div className="w-4 h-4">
            <ImageWrapper
              src="/icons/down-arrow-gray.svg"
              className={`object-cover transform transition duration-250 ${
                isExpanded ? "rotate-180" : ""
              }`}
            />
          </div>
        </div>
      }
      buttonProps={{
        className: `flex items-start border w-full rounded-lg border-[#475569] border-opacity-30 w-full text-base text-left text-[#475569] bg-transparent hover:bg-[#F1F1F1] ${
          isExpanded ? "bg-[#CBD5E140] " : ""
        }`,
      }}
      contentProps={{
        className:
          "transition duration-250 border text-justify text-sm border border-[#475569] rounded-lg p-4 border-opacity-30 text-Default tracking-tight md:tracking-normal leading-5 md:leading-6",
      }}
      panelProps={{ className: "pt-0" }}
    >
      {content}
    </Item>
  );
};

const AccordionItem2 = ({
  header,
  content,
  index,
  expandedIndex,
  setExpandedIndex,
  ...rest
}) => {
  const isExpanded = index === expandedIndex;

  const handleToggle = () => {
    setExpandedIndex(isExpanded ? null : index);
  };

  return (
    <Item
      {...rest}
      header={
        <div
          className="flex justify-between items-center w-full text-start px-10 py-6"
          onClick={handleToggle}
        >
          {header}
          <div className="w-4 h-4 flex items-center justify-center">
            {isExpanded ? (
              <span className="text-[#475569] text-4xl font-bold">-</span>
            ) : (
              <span className="text-[#475569] text-2.5xl font-bold">+</span>
            )}
          </div>
        </div>
      }
      buttonProps={{
        className: `flex items-start bg-[#F7F7F7] w-full text-lg text-left font-medium text-[#333333] hover:bg-[#F1F1F1] ${
          isExpanded ? "bg-[#CBD5E140] " : ""
        }`,
      }}
      contentProps={{
          className:
              "transition duration-250 text-justify bg-[#F7F7F7] text-sm md:text-[15px] px-10 pb-12 text-[#777777] tracking-wide leading-6 md:leading-7 whitespace-pre-line",
      }}
      panelProps={{ className: "pt-0" }}
    >
      {content}
    </Item>
  );
};

const CustomAccordion = ({ items, className, ...accordionProps }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <Accordion
      className={`flex flex-col gap-4 ${className}`}
      {...accordionProps}
    >
      {items.map((item, index) => {
        const { itemType, ...itemProps } = item;
        if (itemType === "item1") {
          return (
            <AccordionItem1
              key={index}
              index={index}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              {...itemProps}
            />
          );
        } else if (itemType === "item2") {
          return (
            <AccordionItem2
              key={index}
              index={index}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              {...itemProps}
            />
          );
        }
        return null;
      })}
    </Accordion>
  );
};

export default CustomAccordion;
